/**
 * è½¬ç ç±»å
 */
export enum TransType {
  MP3 = <any>'MP3',
  MP4 = <any> 'MP4'
}
